<template>
  <div class="room-select-wrapper">
    <!-- <div class="room-select-wrapper__message">Please select chidren age!</div> -->
    <div class="room-select-wrapper__header">
      <span class="icon-Icon-Close" @click="closeModal" />
    </div>
    <div ref="roomContent" class="room-select__content">
      <div>
        <div class="room-select__content__stats">
          <span>{{ $t("booking.you_are_searching_for") }}:</span>
          <div class="total-stats">
            {{ roomList.length }}
            {{ roomList.length > 1 ? $t("booking.rooms") : $t("booking.room") }}
            ,
            {{ totalGuest }}
            {{ totalGuest > 1 ? $t("booking.guests") : $t("booking.guest") }}
          </div>
        </div>
        <div
          v-for="(room, roomIdx) in roomList"
          :key="roomIdx"
          class="room-select__content__detail"
        >
          <RoomDetailSumary
            :room-detail-sumary="{ room, roomIdx }"
            :room-message="roomMessage"
          >
            <div
              v-if="roomList.length > 1"
              class="room-detail__delete"
              @click="$_deleteRoom(roomIdx)"
            >
              <span class="icon-Icon-Delete" />
            </div>
          </RoomDetailSumary>
          <b-collapse
            :id="`room_${roomIdx}`"
            role="tabpanel"
            :visible="roomIdx === visible"
            accordion="my-accordion"
            @show="onCollapes(roomIdx)"
            :class="{ 'room-custom': roomIdx }"
          >
            <AdultSelect
              :person="room.adults"
              person-type="Adults"
              @on:personChange="data => $_onPersonChange(roomIdx, data)"
              @on:visibleChange="$_onVisibleChange"
            />
            <ChildSelect
              :person="room.children"
              :is-error="isError"
              @on:changeChild="data => $_onChildChange(roomIdx, data)"
              @on:changeChildAge="data => $_onChildChangeAge(roomIdx, data)"
              @on:changeBedSelect="data => $_onchangeBedSelect(roomIdx, data)"
              @on:scroll="$_onScroll"
              @on:visibleChange="$_onVisibleChange"
            />
          </b-collapse>
        </div>
      </div>
      <div v-if="tierInfo" class="room-select__content__tier-info">
        <p>{{ tierInfo }}</p>
      </div>
      <div v-else class="room-select__content__tier-info">
        <p>{{ $t("booking.tier_info") }}</p>
      </div>
      <div class="room-select__content__footer">
        <div class="btn-add-room">
          <button
            ref="btnAdd"
            :disabled="roomList.length >= maxRoom"
            class="button m-btn m-btn__white"
            @click="$_addRoomList"
          >
            + {{ $t("booking.add_a_room") }}
          </button>
        </div>
        <div class="rules-mobile">
          <p>{{ rules.rulesTitle }}</p>
          <ul class="rules" v-html="rules.rulesContent"></ul>
        </div>
        <div
          class="btn-apply"
          :class="{
            'ios-safari-padding':
              detectIOS() && detectIphoneModel() && !isToolbarOpen,
            'smaller-model':
              detectIOS() && !detectIphoneModel() && !isToolbarOpen
          }"
        >
          <button class="button m-btn m-btn__yellow" @click="applyModal">
            {{ $t("booking.apply") }}
          </button>
        </div>
      </div>
    </div>
    <div class="room-select__rules">
      <p>{{ rules.rulesTitle }}</p>
      <ul class="rules" v-html="rules.rulesContent"></ul>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";
import AdultSelect from "./AdultSelect.vue";
import ChildSelect from "./ChildSelect.vue";
import RoomDetailSumary from "./RoomDetailSumary.vue";
import Constants from "../../constants/index";
import { BCollapse } from "bootstrap-vue";
Vue.component("b-collapse", BCollapse);
export default {
  name: "RoomSelectContent",
  components: {
    AdultSelect,
    ChildSelect,
    RoomDetailSumary
  },
  props: {
    rules: {
      type: Object,
      default: () => {}
    },

    innerHeight: {
      type: Number,
      default: 0
    },
    tierInfo: String
  },
  data() {
    return {
      maxRoom: Constants.MAX_ROOM,
      visible: 0,
      isError: false,
      isErrorAddRomm: false,
      roomMessage: [],
      isToolbarOpen: false
    };
  },
  computed: {
    ...mapState({
      isShowRoomSelect: state => state.bookingState.roomSelect,
      roomList: state => state.roomList,
      currentRoomActive: state => state.currentRoomActive
    }),
    ...mapGetters({
      isKidsTierSupport: "isKidTiersSupport",
      totalGuest: "totalGuest",
      isMobile: "isMobile"
    })
  },
  watch: {
    roomList: {
      handler(roomList) {
        localStorage.setItem("roomList", JSON.stringify(roomList));
      },
      deep: true
    }
  },
  mounted() {
    this.visible = 0;

    if (this.innerHeight === window.innerHeight) {
      this.isToolbarOpen = true;
    } else {
      this.isToolbarOpen = false;
    }
  },
  destroyed() {
    this.saveCurrentRoomActive(0);
  },
  methods: {
    ...mapActions({
      a_saveRoomList: "a_saveRoomList",
      a_addRoom: "a_addRoom",
      a_deleteRoom: "a_deleteRoom",
      a_onChildChange: "a_onChildChange",
      a_onPersonChange: "a_onPersonChange",
      a_onChildChangeAge: "a_onChildChangeAge",
      closeAll: "closeAll",
      a_onChangeBedSelect: "a_onChangeBedSelect",
      showPromoCode: "showPromoCode",
      saveCurrentRoomActive: "saveCurrentRoomActive"
    }),

    detectIOS() {
      const isIOS = /iPhone/.test(navigator.userAgent) && !window.MSStream;
      let safariAgent = false;
      if (isIOS) {
        const userAgentString = navigator.userAgent;
        let chromeAgent =
          userAgentString.indexOf("Chrome") > -1 ||
          userAgentString.match("CriOS");
        safariAgent = userAgentString.indexOf("Safari") > -1;

        if (chromeAgent && safariAgent) safariAgent = false;
      }

      return safariAgent;
    },

    detectIphoneModel() {
      const iHeight = window.screen.height;
      const iWidth = window.screen.width;
      let isXSMax = false;

      if (
        (iWidth === 320 && iHeight === 568) ||
        (iWidth === 375 && iHeight === 667) ||
        (iWidth === 414 && iHeight === 736)
      ) {
        isXSMax = false;
      } else isXSMax = true;

      return isXSMax;
    },

    $_onVisibleChange() {
      this.visible = 0;
    },

    closeModal() {
      this.closeAll();
    },
    applyModal() {
      this.$_apply();
    },

    $_apply() {
      this.a_saveRoomList(this.roomList);
      this.$_closePopup();
      if (!this.isMobile) {
        this.showPromoCode();
      } else {
        this.closeAll();
      }
    },
    $_addRoomList() {
      this.a_addRoom();
      this.visible = this.roomList.length - 1;
      this.saveCurrentRoomActive(this.visible);
      // this.$nextTick(() => this.$_scrollToEnd())
    },

    $_onPersonChange(roomIndx, person) {
      this.a_onPersonChange({ roomIndx, person });
    },

    $_onChildChange(roomIndx, child) {
      this.a_onChildChange({ roomIndx, child });
    },

    $_onChildChangeAge(roomIdx, data) {
      this.a_onChildChangeAge({ roomIdx, data });
    },

    $_onchangeBedSelect(roomIdx, data) {
      this.a_onChangeBedSelect({ roomIdx, data });
    },

    $_deleteRoom(roomIdx) {
      this.a_deleteRoom(roomIdx);
      this.visible = this.roomList.length - 1;
      this.saveCurrentRoomActive(this.visible);
    },

    $_closePopup() {
      this.$emit("on:showRoom");
    },

    $_onScroll(possiton) {
      if (this.currentRoomActive !== 0) {
        this.visible = 0;
      } else {
        const paddingTop = 50;
        this.$refs.roomContent.scrollTop = possiton - paddingTop;
      }
    },

    $_scrollToEnd() {
      const roomContent = this.$refs.roomContent;
      roomContent.scrollTop = roomContent.scrollHeight;
    },

    $_handler() {
      this.isError = true;
    },

    onCollapes(visible) {
      this.visible = visible;
      this.saveCurrentRoomActive(visible);
      this.$refs["roomContent"].scrollTop = visible * 50;
    }
  }
};
</script>

<style lang="scss" scoped>
.room-select-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: white;
  z-index: 5;
  animation-name: mbsc-anim-p-in;
  animation-duration: 0.3s;
  color: #000;
  display: flex;

  @include min-sm {
    animation-duration: 0.5s;
    width: 720px;
    border-top: 1px solid #e4e4e7;
    border-bottom: 4px solid #ffd25d;
    position: absolute;
    // left: -139%;
    left: -312px;
    top: calc(100% + 28px);
    height: auto;
    @include scrollbar;
    &::before {
      content: "";
      width: 0;
      height: 0;
      border-width: 10px 10px;
      border-style: solid;
      margin-left: -9px;
      border-color: transparent transparent #fff transparent;
      left: 50%;
      top: -20px;
      position: absolute;
      z-index: 6;
      display: none;
      @include min-sm {
        display: block;
      }
    }
  }

  &__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
    position: absolute;
    right: 0;
    span {
      cursor: pointer;
      margin-right: 15px;
      margin-top: 15px;
    }
  }

  &__message {
    height: 40px;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: chocolate;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
  }
}

.room-select {
 
  &__content {
    max-height: 100vh;
    height: 100%;
    overflow: overlay;
    margin-top: 45px;
    // box-shadow: 2px 0px 0px 0 rgba(74, 74, 74, 0.25);
    width: 100%;
    @media screen and (min-width: 0\0) {
      overflow: auto;
    }
    @include min-sm {
      width: 50%;
      margin-top: 30px;
      max-height: 367px;
      min-height: 320px;
      scroll-behavior: smooth;
      @include scrollbar;
      display: -webkit-flex;
      flex-direction: column;
      justify-content: space-between;

      @media screen and (min-width: 0\0) {
        overflow: auto;
      }
    }
    &__tier-info {
      text-align: left;
      font-size: 13px;
      padding: 0 40px;
      @include min-sm {
        border-bottom: none;
        padding: 0 30px;
        // margin-bottom: 10px;
      }
    }
    &__stats {
      text-align: center;
      margin-bottom: 50px;
      span {
        font-size: 12px;
        color: #7b7b85;
      }
      .total-stats {
        font-size: 20px;
        color: #232e48;
        font-weight: normal;
      }
      @include min-sm {
        display: none;
      }
    }
    // &__header {
    //   display: flex;
    //   justify-content: flex-end;
    //   margin-bottom: 30px;
    //   span {
    //     cursor: pointer;
    //     margin-right: 20px;
    //     margin-top: 20px;
    //   }
    // }
    &__detail {
      // margin-bottom: 30px;
      padding: 0 40px;
      @include min-sm {
        border-bottom: none;
        padding: 0 30px;
        // margin-bottom: 10px;
      }
      .room-detail-custom {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        font-size: 14px;
        align-items: center;
      }
    }

    .room-custom {
      opacity: 0.5;
      cursor: not-allowed;
    }
    &__footer {
      align-items: center;
      padding-top: 15px;
      .m-btn__white {
        width: 48%;
        height: 46px;
        width: 280px;

        @include min-sm {
          height: 46px;
        }
      }
      .m-btn__yellow {
        width: 320px;
        padding: 10px 0;
        // box-shadow: 1px 2px 5px 3px rgba(0, 0, 0, 0.2);
      }
      .btn-add-room {
        @include min-sm {
          width: 48%;
        }
      }
      .btn-apply {
        padding: 15px;
        position: fixed;
        bottom: 0;
        width: 100%;
        background: white;
        @include min-sm {
          width: 48%;
          margin-bottom: 0;
          padding: 0;
          position: static;
          @media not all and (min-resolution: 0.001dpcm) {
            @supports (-webkit-appearance: none) {
              .safari_only {
                padding-bottom: initial;
              }
            }
          }
          button {
            width: 100%;
            height: 46px;
          }
        }
      }

      .ios-safari-padding {
        padding-bottom: 70px; // highest in IP
        // padding-bottom: calc(10px + 2 * env(safe-area-inset-bottom));
      }

      .smaller-model {
        padding-bottom: 40px;
      }

      .w-initial {
        @include min-sm {
          width: 140px;
        }
      }
      @include min-sm {
        display: flex;
        padding: 30px;
        padding-top: 15px;
        justify-content: space-between;
        align-items: initial;
        flex-direction: row;
        .m-btn {
          width: 100%;
          outline: none;
          padding: 10px 0;
          box-shadow: none;
        }
      }

      ::v-deep {
        .rules-mobile {
          padding: 30px 25px 25px 25px;
          text-align: left;
          margin-bottom: 120px;
          @include min-sm {
            display: none;
          }
          @include rules;
        }
      }
    }
  }
}

::v-deep {
  .room-select__rules {
    width: 50%;
    padding: 0 18px 18px 18px;
    margin-top: 36px;
    text-align: left;
    display: none;
    // box-shadow: 2px 3px 14px 0 rgba(74, 74, 74, 0.25);
    @include min-sm {
      display: block;
      max-height: 370px;
      overflow: auto;
      @include scrollbar;
    }
    @include rules;
  }
}
</style>
